<template>
  <div class="dialog-image">
    <xl-dialog v-model="show" :title="$t('参数示意图')">
        <template #title>
            <div class="image-title">
            <div>
              <span v-if="VueCookieNext.getCookie('lang') === 'en-us'">{{productName + ' '}}{{ $t('design.orderDetail.imageDialogTitle') || '参数示意图' }}</span>
              <span v-else>{{productName}}{{ $t('design.orderDetail.imageDialogTitle') || '参数示意图' }}</span>
            </div>
        </div>
      </template>
      <typeIndex :currentType="currentType" :paramsBg="paramsBg"></typeIndex>
    </xl-dialog>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, defineEmits, watch } from 'vue';
import {
  XlDialog
} from "@shining3d/ui-components";
import typeIndex from '../design/preference/components/typeIndex.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import { VueCookieNext } from 'vue-cookie-next';
const { $t } = useLang("@shining3d/xl-design-order");

const props = defineProps({
    currentType: String,
    visible: {
    	type: Boolean,
   		default: false
  	},
    productName: String,
    infoList: Array
});

const emits = defineEmits(['update:visible']);

const show = computed({
	get: () => props.visible,
	set: ( val ) => {
		emits( 'update:visible', val );
	}
});
const paramsBg = ref('');
const smileLibrarySelectionMap = {
  '方形': 'Square',
  '三角形': 'Triangular',
  '矩形': 'Rectangular',
}
watch(() => props.currentType, (val) => {
  if( val === 'B'){
    props.infoList.forEach((item) => {
      const data = item?.list?.find((it) => it?.preCode === 'DSD_smileLibrarySelection')
      if( data ){
        paramsBg.value = smileLibrarySelectionMap[data?.preValue] || data?.preValue || ''
      }
    })
  }
}, {immediate: true})
</script>

<style lang="scss" scoped>
.image-title{
    color: $color-n10;
    font-size: 18px;
    font-family: $font-family65;
    font-weight: bold;
}
.dialog-image{
  :deep(.type-image-box svg){
      max-width: 55vw;
      max-height: 62vh;
  }
  :deep(.type-div .img-box){
      max-width: 55vw;
      max-height: 62vh;
  }
}
</style>